import { Logger } from '../logging/logger.js'
/**
 * Creates an instance of RidecellCallback class
 * @constructs RidecellCallback
 * @example
 * const callback = new RidecellCallback();
 * initCallback.onSuccess = (response) => {};
 * initCallback.onFailure = (error) => {};
 **/
export class RidecellCallback { };

    /**
     * Callback function for success.
     * Implement this to receive response object when requested resource was successfully retrieved.
     *
     * @param {Object} result Response based on requested resource.
     * @memberof RidecellCallback
     **/
    RidecellCallback.prototype.onSuccess = result => {  };

    /**
     * Callback function for failure.
     * Implement this to receive error code/message when there was a failure in retrieving the requested resource.
     * @param {Object} error Error based on the request resource.
     * @memberof RidecellCallback
     **/
    RidecellCallback.prototype.onFailure = error => {
        Logger.log(error);
    };